<div class="flex flex-col mt-4 sm:mt-0 px-4 sm:px-0">
  <div class="flex flex-col gap-0.5 mb-2 pb-1">
    <h2 class="text-lg font-semibold">{{ (title || '#UI_CORE.DIALOGS.DATE') | translate }}</h2>
    @if (subtitle) {
      <p class="text-sm font-normal text-light">{{ subtitle | translate }}</p>
    }
  </div>
  <soft-date-range-picker
    class="date-picker"
    [value]="$any(value)"
    (valueChange)="onValueChange($event)"
    [startField]="startField"
    (selectShortcut)="onSelectShortcut($event)"
    #picker
  ></soft-date-range-picker>
</div>

